import { api } from './api';
import {
    AiModelRate,
    AiModelRateInput,
    AiUsageBackfillResult,
    AiUsageCallList,
    AiUsageSummary,
} from '../types/aiUsage.types';

export interface AiUsageQuery {
    from?: string | null;
    to?: string | null;
    page?: number;
    pageSize?: number;
}

const queryString = (params: AiUsageQuery) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            search.set(key, String(value));
        }
    });
    const query = search.toString();
    return query ? `?${query}` : '';
};

/** Read-only ledger endpoints. Writes happen inside the parse route. */
export const aiUsageApi = {
    summary: (params: AiUsageQuery = {}) =>
        api.get<AiUsageSummary>(`/api/ai-usage/summary${queryString(params)}`),

    list: (params: AiUsageQuery = {}) =>
        api.get<AiUsageCallList>(`/api/ai-usage${queryString(params)}`),

    rates: () => api.get<AiModelRate[]>('/api/ai-usage/rates'),

    createRate: (body: AiModelRateInput) =>
        api.post<AiModelRate>('/api/ai-usage/rates', body),

    backfillCosts: (body: { from?: string | null; to?: string | null } = {}) =>
        api.post<AiUsageBackfillResult>('/api/ai-usage/backfill-costs', body),
};
